import { FETCH_GUIDES, SET_ACTIVE_GUIDE } from './constants'
import { CLEAR_CONTENT } from '../App/constants'

const initialState = {
  isFetching: false,
  guides: [],
  activeGuide: null,
  error: '',
  currentPhoneId: ''
}

export default function guideReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GUIDES.REQUEST: {
      return {
        ...state,
        isFetching: true,
        activeGuide: null,
        guides: []
      }
    }
    case FETCH_GUIDES.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        guides: action.guides,
        currentPhoneId: action.currentPhoneId
      }
    }
    case '@@router/LOCATION_CHANGE': {
      return {
        ...state,
        activeGuide: null
      }
    }
    case SET_ACTIVE_GUIDE: {
      return {
        ...state,
        activeGuide: action.activeGuide
      }
    }
    case CLEAR_CONTENT: {
      return {
        ...state,
        tutorials: []
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/Guides/reducer.js